var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4,53.82,53.51,24.37a6,6,0,0,0-5.88-4.83H45V16a13,13,0,0,0-26,0v3.54H16.37a6,6,0,0,0-5.88,4.83L4.6,53.82A6,6,0,0,0,10.48,61h43a6,6,0,0,0,5.88-7.18ZM21,16a11,11,0,0,1,22,0v3.54H21ZM56.61,57.54A4,4,0,0,1,53.52,59h-43a4,4,0,0,1-3.92-4.78l5.89-29.46a4,4,0,0,1,3.92-3.22H19v5.71a1,1,0,0,0,2,0V21.54H43v5.71a1,1,0,0,0,2,0V21.54h2.63a4,4,0,0,1,3.92,3.22l5.89,29.46A4,4,0,0,1,56.61,57.54Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.c6e27bee01f566c369c570dc14a262a7.svg";
export { ForwardRef as ReactComponent };